import { Component } from "@/types"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { Title } from "@/ui/atoms/type/Title"
import { Stack } from "@/ui/atoms/layout/Stack"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "contentBlock"

export const presets = {}

export interface Props extends Component {
  overtitle: string
  title: string
  description: string
  source?: string
}

export function ContentBlock({
  className,
  testId = COMPONENT_NAME,
  overtitle,
  title,
  description,
  source,
}: Props) {
  return (
    <Stack className={cx(`items-start gap-3`, className)} testId={testId}>
      <div className="inline-block text-sm font-semibold pt-2.5 pb-2.5 px-4 bg-current rounded-tl-[2em] rounded-br-[2em]">
        <span className="text-white">{overtitle}</span>
      </div>
      <Title size="xl" className="text-text">
        {title}
      </Title>
      <BodyText size="lg" className="text-text-secondary font-light lg:text-[18px]">
        {description}
      </BodyText>
      {source && (
        <div className="text-sm text-text-secondary font-light">
          <span className="text-text-secondary font-light">Source: {source}</span>
        </div>
      )}
    </Stack>
  )
}
